import { render } from "./StackComponent.vue?vue&type=template&id=fceca516&scoped=true"
import script from "./StackComponent.vue?vue&type=script&lang=js"
export * from "./StackComponent.vue?vue&type=script&lang=js"

import "./StackComponent.vue?vue&type=style&index=0&id=fceca516&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fceca516"]])

export default __exports__